import { render, staticRenderFns } from "./VerifyResetPassword.vue?vue&type=template&id=1a17b844&"
import script from "./VerifyResetPassword.vue?vue&type=script&lang=js&"
export * from "./VerifyResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports